export default __webpack_public_path__ + "static/media/international.5d6d258e.svg";